{
  "en": {
    "datatable": {
      "actions": {
        "add_filter": "Add filter",
        "bulk_action": "Bulk action",
        "bulk_edit": "Bulk edit",
        "clear": "Clear",
        "clear_filters": "Clear filters",
        "collapse_all": "Collapse all",
        "collapse_row": "Collapse row",
        "deselect_all": "Deselect all",
        "expand_all": "Expand all",
        "expand_row": "Expand row",
        "filters": "Filters",
        "remove_filter": "Remove filter {label}: {value}",
        "select_all": "Select all",
        "select_row": "Select row"
      },
      "import": {
        "error_row": "Row {row}",
        "errors_description": "The import was cancelled because {count} row(s) contained errors. No records were imported.",
        "errors_title": "Import failed",
        "success": "File imported successfully",
        "title": "Import"
      },
      "labels": {
        "active_filters": "Active filters",
        "columns_selected": "{count} columns selected",
        "freeze_columns": "Freeze columns",
        "freeze_rows": "Freeze rows",
        "gridlines": "Grid lines",
        "group_by": "Group by",
        "size": "Size",
        "sticky_headers": "Sticky headers",
        "striped_rows": "Striped rows",
        "toggle_columns": "Toggle columns",
        "translation_mode_header": "Header",
        "translation_mode_stacked": "Stacked",
        "translation_mode_toolbar": "Global",
        "translation_style": "Translation style"
      }
    }
  }
}
